// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"20f3ce64","29":"29f384ee","181":"8f2fbc91","274":"8bb9e478","289":"8a9732f5","367":"3a155701","404":"40cbf95d","479":"8bd04340","488":"74ff7f89","578":"13f6c940","685":"17e9605b","702":"ad39ff04","766":"c154af57","881":"86dc6944","949":"c567de8a"}[chunkId] + ".chunk.js";
};